export const experienceData = [
    {
        id: 1,
        company: 'Federal Home Loan Bank',
        jobtitle: 'Full Stack Developer',
        startYear: 'July 2023',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Federal Home Loan Bank',
        jobtitle: 'DevOps Engineer Intern',
        startYear: 'May 2022',
        endYear: 'August 2022'
    },
    {
        id: 3,
        company: 'Minerals Technologies Inc.',
        jobtitle: 'Information Technology Intern',
        startYear: 'August 2020',
        endYear: 'April 2021'
    },
]